var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"roads-container"},[_c('map-wrapper'),_c('road-list',{on:{"remove-road":_vm.onRemoveRoad}}),_c('controls',{on:{"render-road":_vm.onRenderRoad,"render-range":_vm.onRenderRange,"show-map":_vm.onShowMap}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }